import React, { useEffect } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';

const UserSearchForm = (props) => {
    const [form] = Form.useForm();

    const onFinish = (values: any) => {
        props.extendedSearch(values);
    };

    const clear = () => {
        form.resetFields();
        props.clear();
    };

    useEffect(() => {
        form.setFieldValue('fullName', props.search);
    }, [props.search]);

    return (
        <Form
            form={form}
            className="my-3"
            layout="vertical"
            onFinish={onFinish}
        >
            <Row gutter={15}>
                <Col
                    xs={24}
                    lg={12}
                >
                    <Form.Item
                        label="ФИО"
                        name="fullName"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col
                    xs={24}
                    lg={12}
                >
                    <Form.Item
                        label="ИИН/БИН"
                        name="taxpayerCode"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col
                    xs={24}
                    lg={12}
                >
                    <Form.Item
                        label="Email"
                        name="email"
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <hr className="mb-4" />

            <Row gutter={15}>
                <Col>
                    <Button onClick={clear}>Очистить</Button>
                </Col>
                <Col>
                    <Button
                        type="primary"
                        htmlType="submit"
                        color="gold"
                    >
                        Применить
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default UserSearchForm;
